// ReportProjectTitleCell Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IntlUtil from '../../../lib/intlutil.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import CellContainer from '../../../../components/ListCell/CellContainer.jsx'

class ReportProjectTitleCell extends Component {
  static propTypes = {
    info: PropTypes.object,
    width: PropTypes.string,
    onView: PropTypes.func
  };

  static defaultProps = {
    info: null,
    width: null,
    onView: null
  };

  render () {
    const { info, onView, width } = this.props

    return (
      <CellContainer
        width={width}
        className='report-project-titlecell list-cell'
      >
        <div className='listrowcell'>
          <div className='cont'>
            <div className='contleft'>
              <span className='title' onClick={onView}>
                {info.title}
              </span>

              {info.projectSubtitle && (
                <span className='info'>{info.projectSubtitle}</span>
              )}

              <span className='info'>{info.subTitle}</span>

              {info.projectManagerName && (
                <span className='info'>{info.projectManagerName}</span>
              )}
            </div>

            {info.values && info.values.length > 0 && (
              <div className='contright'>{this._renderItems()}</div>
            )}
          </div>
        </div>
      </CellContainer>
    )
  }

  /* Even handlers */

  /* Private Function */
  _renderItems () {
    const { info } = this.props
    return info.values.map((valueObj, idx) => {
      return (
        <div className='info-item' key={idx}>
          <span className='title'>
            {IntlUtil.convertMessage(valueObj.label)}
          </span>
          <span className='value'>
            {valueObj.value ? <PriceText value={valueObj.value} /> : '-'}
          </span>
        </div>
      )
    })
  }
}

export default ReportProjectTitleCell
